import { Component, createApp } from "vue";

export function mountVue(options: Component) {
    document.querySelectorAll('[data-vue]').forEach((element) => {
        const app = createApp(options);
        app.config.globalProperties.console = console;
        // @ts-ignore
        app.config.globalProperties.CustomEvent = CustomEvent;
        window.Sentry.attachErrorHandler(app, {
            attachProps: true,
            logErrors: true,
            timeout: 2000,
            trackComponents: false,
            hooks: ['activate', 'mount', 'update'],
        });
        app.mount(element);
    });
}
